module.exports = __webpack_public_path__ + "static/media/sloss.08e938d6.jpg";